module.exports = __webpack_public_path__ + "static/media/Lindsay Kamowski Headshot.bdb181b2.jpeg";